import type { Action } from './actions'
import type { CurriculumState } from './contracts'
import { libraryReducer } from './library-reducer'
import { plannerReducer } from './planner-reducer'

export const curriculumReducer = (
  state: CurriculumState,
  action: Action,
): CurriculumState => {
  switch (action.type) {
    case 'dismiss-flash':
    case 'add-auto':
    case 'stage-to-tray':
    case 'remove-from-tray':
    case 'toggle-placing':
    case 'cancel-placing':
    case 'place-at':
    case 'place-card-at':
    case 'remove-from-day':
    case 'move-card-to':
    case 'distribute-tray':
    case 'optimize-schedule':
    case 'publish-week':
    case 'unpublish-week':
    case 'delete-week':
    case 'add-week':
    case 'set-budget':
    case 'toggle-week':
    case 'add-custom-card':
    case 'convert-to-ai-mock':
    case 'revert-ai-mock':
    case 'link-ai-mock':
    case 'add-interview-tier':
      return plannerReducer(state, action)
    case 'apply-preset':
    case 'set-filters':
    case 'set-sorts':
    case 'set-type-filter':
    case 'cycle-company-tag':
    case 'cycle-seen-filter':
    case 'toggle-column':
    case 'set-column-order':
    case 'set-library-tab':
      return libraryReducer(state, action)
    default: {
      action satisfies never
      return state
    }
  }
}
